import type React from 'react';
import { StyleSheet, Text, type TextStyle } from 'react-native';

import { Greys } from '@/ui/common/colors';

const BoldCaption = ({
  children,
  style,
  ...props
}: {
  children?: React.ReactElement | string;
  style?: TextStyle;
}) => {
  return (
    <Text style={[styles.text, style]} {...props}>
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  text: {
    color: Greys.shade500,
    fontFamily: 'OpenSans-Bold',
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 14,
    textAlign: 'center',
  },
});

export default BoldCaption;
